<template>
    <div class="page">
        <img
            class="back"
            @click="back()"
            src="~@/assets/2020year-end/back.png"
            alt=""
        />
        <img
            v-if="myIndex"
            class="banner"
            :src="require(`../../assets/2020year-end/${myIndex}.png`)"
            alt=""
        />
        <div class="title">{{ title }}</div>
        <div class="content" v-html="wordPic"></div>
    </div>
</template>

<script>
    import yearEndService from "../../service/2020year-end.service";
    export default {
        name: "year-end-article",
        data() {
            return {
                courseId: "",
                id: "",
                wordPic: "",
                myIndex: undefined,
                title: "",
            };
        },
        created() {
            this.courseId = this.$route.query.courseId;
            this.id = this.$route.query.id;
            if (this.courseId && this.id) {
                this.getEpisodeDetail();
            }
        },
        methods: {
            getEpisodeDetail() {
                yearEndService
                    .getEpisodeDetail(this.courseId, this.id)
                    .then((res) => {
                        this.wordPic = res.data.wordPic;
                        this.myIndex = res.data.myIndex;
                        this.title = res.data.title;
                    });
            },
            back() {
                this.$router.push({
                    path: "../2020year-end",
                    query: { loadingPage: 0 },
                });
            },
        },
    };
</script>

<style lang="scss" scoped src="./2020year-end-article.scss"></style>
